import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const WeatherChart = ({ weatherData }) => {
  if (!weatherData) return null;

  const data = {
    labels: ['Wind Speed', 'Rainfall Interval', 'Total Rainfall'],
    datasets: [
      {
        label: 'Weather Measurements',
        data: [
          weatherData.windSpeed || 0,
          weatherData.rainfallInterval || 0,
          weatherData.totalRainfall || 0,
        ],
        backgroundColor: [
          'rgba(33, 150, 243, 0.8)', // Blue for wind
          'rgba(76, 175, 80, 0.8)',  // Green for interval rainfall
          'rgba(63, 81, 181, 0.8)',  // Indigo for total rainfall
        ],
        borderColor: [
          'rgba(33, 150, 243, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(63, 81, 181, 1)',
        ],
        borderWidth: 2,
        borderRadius: 8,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.parsed.y || 0;
            let unit = '';
            
            if (label.includes('Wind')) {
              unit = ' km/h';
            } else if (label.includes('Rainfall')) {
              unit = ' mm';
            }
            
            return `${label}: ${value}${unit}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
        ticks: {
          font: {
            size: 11,
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 11,
          },
          maxRotation: 45,
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default WeatherChart;
